
//查询主菜单

import service from '../utils/request'; 
export const fetchMenus = async () => {
  try {
    const response = await service.get('/apis/api.halo.run/v1alpha1/menus/primary');
    return response;  // 这里返回的是 `service` 已经处理过的响应数据
  } catch (error) {
    console.error('获取菜单失败:', error);
    throw error;
  }
};
